import ThomsonReutersConfigurer from './ThomsonReutersConfigurer';

export default ThomsonReutersConfigurer;
